import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import AutoPolicies from './auto'
import NonAutoPolicies from './non-auto'

interface PoliciesProps {
    defaultType?: 'motor' | 'non-motor';
}

const Policies = ({ defaultType }: PoliciesProps) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const type = searchParams.get('type');


    return (
        <> { type &&
            <div>
                {type === 'motor' ? <AutoPolicies /> : <NonAutoPolicies />}
            </div>}
        </>
    )
}

export default Policies